<!--
 * @Author: zhangjiangpo
 * @Date: 2023-12-22 17:31:13
 * @LastEditors: zhangjiangpo
 * @LastEditTime: 2023-12-25 11:17:23
 * @Description:
-->
<template>
  <a-input-number
    :style="inputStyle"
    v-model="goldVal"
    type="number"
    :key="rowKey"
  />
</template>

<script>

export default {
  name: 'GoldInput',
  props: {
    rowKey: {
      type: Number,
      default: -1
    },
    val: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      inputStyle: {},
      goldVal: ''
    }
  },
  watch: {
    goldVal(val) {
      this.inputStyle = {
        color: val > 1000 ? 'red' : 'inherit'
      }
      this.$emit('goldChange', this.rowKey, val)
    },
    val(val) {
      this.goldVal = val
    }
  }
}
</script>